<template>
    <!-- 底部聊天输入框及表情输入框等 -->
    <div class="discuss-bottom-bar-box">
        <!-- 聊天输入框 -->
        <div class="discuss-bottom-input-bar">
            <div v-if="curDiscussQuoteData && curDiscussQuoteData.id" class="discuss-bottom-input-top-content pad-b-5">
                <div class="discuss-bottom-quote-content dsp-flex">
                    <div class="discuss-bottom-qb-content">
                        <p>{{curDiscussQuoteData.nickname+'：'+curDiscussQuoteData.content}}</p>
                        <!-- <p>何兰豆：嗯，她今年地支寅午戌三合，申子辰三合，也很不稳定非常不稳定…</p> -->
                    </div>
                    <div class="discuss-bottom-qb-cancel" @click="clickClose">
                        <i class="iconfont icon-close-solid"></i>
                    </div>
                </div>
            </div>
            <div class="discuss-bottom-input-content dsp-flex">
                <!-- Todo::::先隐藏语音入口 -->
                <!-- <div class="discuss-bottom-item" @click="clickRecordButton"> -->
                <!-- <div class="discuss-bottom-item"> -->
                    <!-- <i class="iconfont" v-bind:class="{'icon-voice': !showRecordButton, 'icon-keyboard': showRecordButton}"></i> -->
                <!-- </div> -->
                <!-- <div class="discuss-bottom-item" @click="clickPlus">
                    <i class="iconfont icon-expand"></i>
                </div> -->
                <div class="discuss-bottom-item pr" @click="clickDeepSeek">
                    <div v-if="showTips" class="deep-seek-tips tips-2"></div>
                    <div class="deep-seek-button"></div>
                </div>
                <div v-if="!showRecordButton" class="discuss-bottom-input-item discuss-bottom-input-item-new">
                    <!-- <form action="javascript:void(0)"> -->
                        <!-- <input class="discuss-bottom-input" type="text" /> -->
                        <!-- <input class="discuss-bottom-input" type="text" confirm-type="done" /> -->
                    <!-- </form> -->
                    <!-- 引用框 -->
                    <textarea id="discussText" class="discuss-bottom-textarea" placeholder="请输入信息" name="" cols="30" rows="1" maxlength="2000" v-model="textValue" @focus="focusTextArea" @blur="blurTextArea" @input="inputTextArea"></textarea>
                    <div id="fakeText" class="discuss-bottom-fake-textarea" @click="clickFakeTextArea">fake</div>
                </div>
                <div v-if="showRecordButton" class="discuss-bottom-input-item">
                    <button class="discuss-button-record">按住 说话</button>
                </div>
                <div class="discuss-bottom-item" @click="clickExpButton">
                    <i class="iconfont" v-bind:class="{'icon-expression': !showExpressions, 'icon-keyboard': showExpressions}"></i>
                </div>
                <!-- <div class="discuss-bottom-item" @click="clickExpandButton">
                    <i class="iconfont icon-expand"></i>
                </div> -->
                <div class="discuss-bottom-item" @click="clickSendButton">
                    <span class="discuss-button-send" v-bind:class="{'discuss-button-send-gray': !canSend}">发送</span>
                </div>
            </div>
        </div>
        <!-- 表情列表框 -->
        <div v-if="showExpressions" class="discuss-bottom-expression-list">
            <van-swipe indicator-color="white" :loop="false" :stop-propagation="false" :initial-swipe='curIndex' @change="onChange">
                <van-swipe-item v-for="expList of expressionList" v-bind:key="'expression-' + expList.length + Math.random(0, 10)">
                    <span v-for="expression of expList" v-bind:key="'expression-' + expression + Math.random(0, 10)" @click.stop="clickExpression(expression)">{{expression.content}}</span>
                </van-swipe-item>
            </van-swipe>
            <div class="discuss-bottom-expression-bar dsp-flex">
                <div class="discuss-beb-item" @click="clickDelete"><span><i class="iconfont icon-jianpanguanbi"></i></span></div>
            </div>
        </div>
    </div>
</template>

<script>
import he from 'he'
import { WEIXIN, WEIXIN_CHAT } from '../../modules/weixin'
import { WS } from '../../modules/websocket';
import { UA, UTILS } from '../../modules/utils';
import { DISCUSS_DOM } from '../../modules/dom'
import { CONST_DISCUSS_MSG_TYPE } from '../../modules/data/base/consts';
export default {
    name: 'DiscussBottomBar',
    computed: {
        userInfo() {
            return this.$store.state.userData;
        },
        curUserUid() {
            return this.$store.state.discuss.curUserUid;
        },
        curMsgType() {
            return this.$store.state.discuss.curMsgType;
        },
        expressionList() {
            return this.$store.state.discuss.expressionList;
        },
        curDiscussQuoteData() {
            return this.$store.state.discuss.curDiscussQuoteData;
        },
        lunpanRoomAllUserObject() {
            return this.$store.state.discuss.lunpanRoomAllUserObject;
        },
        lunpanRoomSelectedUserData() {
            return this.$store.state.discuss.lunpanRoomSelectedUserData
        },
    },
    data() {
        return {
            showTips: window.localStorage.getItem('h5_fate_ds_discuss_tips') ? false : true,
            canSend: false,
            sendLock: false,
            tempText: '',
            textValue: '',
            showExpressions: false,
            showRecordButton: false,
            curIndex: 0,
            tempAtText: ''
        }
    },
    created() {
        // 监听软件盘呼起or隐藏的事件
        var me = this,
            textNode = document.getElementById('discussText'),
            originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
        window.onresize = function() {
            if(textNode) {
                textNode.blur();
            }
            setTimeout(() => {
                DISCUSS_DOM.updateDiscussPageStyle();
            }, 0);
            if(UA.isIphone()) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussFormStyle();
                    me.$bus.emit('scrollToDiscussBottom');
                    DISCUSS_DOM.resetDiscussFormScrollStyle();
                }, 0);
            }else if(UA.isAndroid()) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussFormStyle();
                    me.$bus.emit('scrollToDiscussBottom');
                    var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
                    if(parseInt(originalHeight) > parseInt(resizeHeight)) {
                        DISCUSS_DOM.updateDiscussFormScrollStyle();
                    }else{
                        DISCUSS_DOM.resetDiscussFormScrollStyle();
                    }
                }, 0);
            }
        }
    },
    mounted() {
        this.$bus.on('updateDiscussAtText', this.updateAtText);
        this.$bus.on('updateDiscussAtAvatarText', this.updateAtAvatarText);
        this.$bus.on('triggerBindKeyDownEvent', this.focusTextArea);
        this.$bus.on('triggerDiscussFocused', this.clickFakeTextArea);
    },
    destroyed() {
        this.$bus.off('updateDiscussAtText', this.updateAtText);
        this.$bus.off('updateDiscussAtAvatarText', this.updateAtAvatarText);
        this.$bus.off('triggerBindKeyDownEvent', this.focusTextArea);
        this.$bus.off('triggerDiscussFocused', this.clickFakeTextArea);
    },
    methods: {
        /**
         * 语音按钮事件
         */
        clickRecordButton() {
            this.showRecordButton = !this.showRecordButton;
            this.showExpressions = false;
            if(!this.showRecordButton) {
                this.textValue = '';
            }
        },
        clickPlus() {
            this.$store.state.discuss.showDiscussDownloadPop = true;
        },
        /**
         * 表情按钮事件
         */
        clickExpButton() {
            this.showExpressions = !this.showExpressions;
            this.showRecordButton = false;
            var fakeNode = document.getElementById('fakeText');
            if(fakeNode) {
                fakeNode.style.display = 'block';
            }
            var me = this;
            if(this.showExpressions) {
                this.blurTextArea();
            }else {
                if(UA.isIphone()) {
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                        DISCUSS_DOM.updateDiscussPageStyle();
                        DISCUSS_DOM.updateDiscussFormStyle();
                        me.$bus.emit('scrollToDiscussBottom');
                        DISCUSS_DOM.resetDiscussFormScrollStyle();
                    }, 10);
                }else {
                    this.clickFakeTextArea();
                }
            }
        },
        clickDeepSeek() {
            var lunpanData = this.$store.state.discuss.lunpanData;
            console.log('clickDS', lunpanData);
            if(!lunpanData || !lunpanData.hid) { return; }
            if(this.showTips) {
                window.localStorage.setItem('h5_fate_ds_discuss_tips', '1');
                this.showTips = false;
            }
            this.$showDeepSeek({
                id: lunpanData.hid, type: 1,
                topClass: 'discuss-fate-topbar',
            });
        },
        /**
         * 发送按钮事件
         */
        clickSendButton() {
            if(!this.canSend) { return; }
            if(this.sendLock) { return; }

            this.sendLock = true;
            var me = this;
            setTimeout(() => {
                me.sendLock = false;
            }, 500);
            // 空的字符串or全是换行符 不发送
            if(this.textValue.match(/^\s+$/) ||
                this.textValue.match(/^[ ]+$/) ||
                this.textValue.match(/^[ ]*$/) ||
                this.textValue.match(/^\s*$/)){
                this.textValue = '';
                this.canSend = false;
                this.$toast("不能发送空白消息");
                setTimeout(() => {
                    me.updateTextAreaHeight();
                }, 100);
                return;
            }
            // 处理发送的数据
            var textContent = this.textValue;
            // 发送的是带回复的内容:设置msg_type和内容;
            if(this.curDiscussQuoteData && this.curDiscussQuoteData.id) {
                this.$store.state.discuss.curMsgType = CONST_DISCUSS_MSG_TYPE.reply;
                textContent = JSON.stringify({
                    r: this.textValue,
                    id: this.curDiscussQuoteData.id
                });
            }
            var params = {
                uid: this.curUserUid,
                msg_type: this.curMsgType,
                content: textContent
            }
            console.log('sendMessage-------', this.curUserUid, this.curMsgType, this.lunpanRoomSelectedUserData);
            this.$store.dispatch('discuss/sendMyWSMessage', params);
            // 发送的是带at的内容
            if(this.curMsgType == CONST_DISCUSS_MSG_TYPE.at) {
                textContent = this.replaceAtContent(textContent);
            }
            // console.error('textContent-------', textContent)
            WS.sendMessageWS({
                msg_type: this.curMsgType,
                content: textContent
            });
            setTimeout(() => {
                me.resetForm();
                window.scrollTo(0, 0);
                me.$bus.emit('initDiscussHistoryList');
                DISCUSS_DOM.updateDiscussPageStyle();
                DISCUSS_DOM.updateDiscussFormStyle();
                DISCUSS_DOM.resetDiscussFormScrollStyle();
            }, 20);
        },
        /**
         * textarea上的空白遮罩层
         */
        clickFakeTextArea() {
            var me = this,
                fakeNode = document.getElementById('fakeText'),
                textNode = document.getElementById('discussText'),
                leng = this.textValue.length;
            if(fakeNode) {
                fakeNode.style.display = 'none';
            }
            if(textNode) {
                textNode.setSelectionRange(leng, leng);
                textNode.focus();
            }

            // 设置迷你命盘运盘的行数:::如果显示3行的话隐藏1行，输入状态下最多只显示2行；
            var showLines = this.$store.state.minifatefortune.showLines;
            if(showLines == 2) {
                this.$store.state.minifatefortune.showLines = 1;
            }
            
            var originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
            if(UA.isPcWeChat()) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussPageStyle();
                    DISCUSS_DOM.updateDiscussFormStyle();
                    DISCUSS_DOM.updateDiscussFormScrollStyle();
                    me.$bus.emit('initDiscussHistoryList');
                    me.$bus.emit('scrollToDiscussBottom');
                }, 0);
            }else if(UA.isIphone()) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussPageStyle();
                    DISCUSS_DOM.updateDiscussFormStyle();
                    DISCUSS_DOM.updateDiscussFormScrollStyle();
                    me.$bus.emit('initDiscussHistoryList');
                    me.$bus.emit('scrollToDiscussBottom');
                    // document.body.addEventListener('touchmove', me.stopTouch, { passive: false, capture: true })
                }, 100);
            }else if(UA.isAndroid()) {
                window.onresize = function() {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussPageStyle();
                    DISCUSS_DOM.updateDiscussFormStyle();
                    var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
                    if(parseInt(originalHeight) > parseInt(resizeHeight)) {
                        DISCUSS_DOM.updateDiscussFormScrollStyle();
                    }else{
                        DISCUSS_DOM.resetDiscussFormScrollStyle();
                    }
                    me.$bus.emit('initDiscussHistoryList');
                    me.$bus.emit('scrollToDiscussBottom');
                }
            }
        },
        focusTextArea() {
            this.showExpressions = false;
            if(UA.isPcWeChat()){
                this.bindKeyDownEvent();
            }
        },
        blurTextArea() {
            var me = this,
                fakeNode = document.getElementById('fakeText');
            if(fakeNode) {
                fakeNode.style.display = 'block';
            }            
            var originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
            // pc上的微信添加enter发送事件
            if(UA.isPcWeChat()) {
                this.unBindKeyDownEvent();
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussPageStyle();
                    DISCUSS_DOM.updateDiscussFormStyle();
                    me.$bus.emit('initDiscussHistoryList');
                    me.$bus.emit('scrollToDiscussBottom');
                    DISCUSS_DOM.resetDiscussFormScrollStyle();
                }, 0);
            }else if(UA.isIphone()) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussPageStyle();
                    DISCUSS_DOM.updateDiscussFormStyle();
                    me.$bus.emit('initDiscussHistoryList');
                    me.$bus.emit('scrollToDiscussBottom');
                    DISCUSS_DOM.resetDiscussFormScrollStyle();
                    // document.body.style = '';
                    // document.body.removeEventListener('touchmove', me.stopTouch, { capture: true })
                }, 100);
            }else if(UA.isAndroid()) {
                window.onresize = function() {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussPageStyle();
                    DISCUSS_DOM.updateDiscussFormStyle();
                    me.$bus.emit('initDiscussHistoryList');
                    me.$bus.emit('scrollToDiscussBottom');
                    var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
                    if(parseInt(originalHeight) > parseInt(resizeHeight)) {
                        DISCUSS_DOM.updateDiscussFormScrollStyle();
                    }else{
                        DISCUSS_DOM.resetDiscussFormScrollStyle();
                    }
                }
            }

        },
        inputTextArea() {
            var me = this;
            setTimeout(() => {
                var tLen = me.tempText.length,
                    ttLen = me.textValue.length;
                me.canSend = ttLen > 0 ? true : false;
                // console.error('inputTextArea-------', me.tempText, me.textValue)
                if(me.canSend) {
                    var lastW = me.textValue.charAt(ttLen-1);
                    if(tLen <= ttLen && lastW == '@') {
                        me.gotoChoosePeoplePage();
                    }
                    if(tLen > ttLen) {
                        var delW = me.tempText.charAt(tLen-1);
                        var lastW = '', curL = ttLen-1;
                        while(lastW != '@') {
                            lastW = me.textValue.charAt(curL);
                            curL--;
                            delW = lastW != '' ? lastW + delW : delW;
                            if(lastW == '@' || curL <= 0) {
                                break;
                            }
                        }
                        var sIndex = _.findIndex(me.lunpanRoomSelectedUserData, sData=>{return sData.nickname == delW}),
                            atIndex = me.textValue.indexOf('@');
                        if(sIndex != -1) {
                            me.textValue = me.tempText.slice(0, atIndex);
                        }
                    }
                }
                me.tempText = me.textValue;
                me.updateTextAreaHeight();
                me.checkTextValue();
            }, 10);
        },
        stopTouch(e) {
            e.preventDefault()
        },
        updateTextAreaHeight() {
            // 自动撑开输入框的高度
            var me = this,
                fakeNode = document.getElementById('fakeText'),
                textNode = document.getElementById('discussText');
            
            if(this.textValue.length == 0) {
                fakeNode.style.height = '';
                textNode.style.height = '';
            }else {
                fakeNode.style.height = textNode.scrollHeight + 'px';
                textNode.style.height = textNode.scrollHeight + 'px';
            }
            // 更新外层的样式和位置
            if(UA.isIphone()) {
                setTimeout(() => {
                    me.$bus.emit('scrollToDiscussBottom');
                }, 0);
            }else {
                window.scrollTo(0, 0);
                DISCUSS_DOM.updateDiscussPageStyle();
                DISCUSS_DOM.updateDiscussFormStyle();
                me.$bus.emit('scrollToDiscussBottom');
            }
        },
        /**
         * 绑定回车按钮事件
         */
        bindKeyDownEvent() {
            var me = this;
            document.onkeydown = function(e) {
                // 兼容FF和IE和Opera
                var event = e || window.event;
                var key = event.which || event.keyCode || event.charCode;
                // console.error('onkeydown------', key, event);
                var bCtrlKeyCode = event.ctrlKey || event.metaKey,
                    bShiftKeyCode = event.shiftKey;
;
                // ctrl + enter 换行
                if (key == 13 && bCtrlKeyCode) {
                    return;
                }
                // 监听@键:跳转到@列表页面
                // if (key == 50 && bShiftKeyCode) {
                //     me.gotoChoosePeoplePage();
                // }
                // 监听回车键
                if (key == 13) {
                    event.preventDefault();
                    me.clickSendButton();
                }
            };
        },
        /**
         * 撤销绑定回车按钮事件
         */
        unBindKeyDownEvent() {
            document.onkeydown = null;
        },
        /**
         * 点击表情事件
         */
        clickExpression(expressionData) {
            this.textValue = this.textValue + expressionData.code;
            this.canSend = this.textValue.length > 0 ? true : false;
            this.tempText = this.textValue;
            this.updateTextAreaHeight();
            return false;
        },
        /**
         * 表情输入框里的删除输入事件
         */
        clickDelete() {
            if(this.textValue == '') {
                return;
            }
            var me = this, curText = he.encode(this.textValue), newText = '',
                lastChar = curText.charAt(curText.length - 1),
                exppChar = curText.charAt(curText.length - 1 - 7),
                expppChar = curText.charAt(curText.length - 1 - 8),
                wordpChar = curText.charAt(curText.length - 1 - 6),
                wordppChar = curText.charAt(curText.length - 1 - 7);
            if(lastChar == ';') {
                // 删除表情
                if(exppChar == '#' && expppChar == '&') {
                    newText = curText.slice(0, curText.length - 9);
                }else if(wordpChar == '#' && wordppChar == '&'){
                    newText = curText.slice(0, curText.length - 8);
                }else{
                    newText = curText.slice(0, curText.length - 1);
                }
            }else if(lastChar){
                // 删除@的值

            }else {
                newText = curText.slice(0, curText.length - 1);
            }
            this.textValue = he.decode(newText);
            this.canSend = this.textValue.length > 0 ? true : false;
            this.tempText = this.textValue;

            setTimeout(() => {
                me.updateTextAreaHeight();
            }, 0);
        },
        resetForm() {
            this.textValue = '';
            this.showExpressions = false;
            this.$store.state.discuss.curMsgType = CONST_DISCUSS_MSG_TYPE.text;
            this.$store.state.discuss.lunpanRoomSelectedUserData = [];

            this.updateTextAreaHeight();
            var fakeNode = document.getElementById('fakeText'),
                textNode = document.getElementById('discussText');
            if(fakeNode) {
                fakeNode.style.height = '';
            }
            if(textNode) {
                textNode.style.height = '';
            }
        },
        clickExpandButton() {
            var me = this;
            WEIXIN_CHAT.chooseImage(function(localId, localData){
                me.$store.dispatch('discuss/chatSendImage', {
                    localId: localId, localData: localData
                })
            });
        },
        onChange(index) {
            this.curIndex = index;
        },
        clickClose() {
            this.$store.state.discuss.curDiscussQuoteData = {};
        },
        /**
         * 跳转到选择at列表页面
         */
        gotoChoosePeoplePage(){
            var me = this,
                curPath = this.$router.history.current.path;
                curPath = curPath.indexOf('/choosepeople') == -1 ? curPath + '/choosepeople' : curPath;
            var keysList = _.keysIn(this.lunpanRoomAllUserObject);
            console.log('gotoChoosePeoplePage-----', keysList);
            if(keysList.length == 0) { return; }
            if(UA.isPcWeChat()) {
                this.unBindKeyDownEvent();
            }
            this.blurTextArea();
            setTimeout(() => {
                me.$router.push({
                    path: curPath
                });
            }, 300);
        },
        updateAtText() {
            // console.error('updateAtText-------', this.lunpanRoomSelectedUserData, this.textValue, this.tempAtText)
            // 如果是@的话，就删掉@了
            // if(this.textValue.charAt(this.textValue.length-1) == '@') {
            //     this.textValue = this.textValue.slice(0, -1);
            // }
            if(this.lunpanRoomSelectedUserData.length == 0) { 
                var tempIndex = this.textValue.indexOf(this.tempAtText),
                    tempLen = this.tempAtText.length;
                // console.error('tempAtText--------', this.tempAtText, tempIndex, tempLen)
                if(this.tempAtText != '' && tempIndex != -1) {
                    var tempArr = this.textValue.split(''),
                        arr1 = tempArr.splice(0, tempIndex), arr2 = tempArr.splice(tempIndex+tempLen),
                        tempStr = arr1.join('') + arr2.join('');
                    // console.error('删除完了', tempIndex, tempLen, arr1, arr2)
                    this.textValue = tempStr;
                    this.tempText = this.textValue;
                    this.tempAtText = '';
                }
                return;
            }
            var me = this;
            _.forEach(this.lunpanRoomSelectedUserData, data=> {
                var tempText = '@' + data.nickname;
                if(me.textValue.indexOf(tempText) == -1) {
                    me.textValue = me.textValue+data.nickname+' ';
                    me.tempAtText = me.tempAtText+data.nickname+' ';
                }
            });
            this.tempText = this.textValue;
            var len = this.lunpanRoomSelectedUserData.length;
            this.$store.state.discuss.curMsgType = len > 0 ? CONST_DISCUSS_MSG_TYPE.at : CONST_DISCUSS_MSG_TYPE.text;
            this.clickFakeTextArea();
        },
        updateAtAvatarText(atData) {
            var curIndex = _.findIndex(this.lunpanRoomSelectedUserData, data=>{return data.uid == atData.uid});
            if(curIndex == -1) {
                this.textValue += '@'+atData.nickname+' ';
                this.$store.state.discuss.lunpanRoomSelectedUserData.push({
                    avatar: atData.avatarUrl,
                    firstL: UTILS.getFirstLetterByName(atData.nickname),
                    nickname: atData.nickname,
                    selected: true,
                    uid: atData.uid
                });
            }
            var firstL = UTILS.getFirstLetterByName(atData.nickname),
                sIndex = _.findIndex(this.lunpanRoomAllUserObject[firstL], data=>{return data.uid == atData.uid} );
            if(sIndex != -1) {
                this.$store.state.discuss.lunpanRoomAllUserObject[firstL][sIndex].selected = true;
            }
            var len = this.lunpanRoomSelectedUserData.length;
            this.$store.state.discuss.curMsgType = len > 0 ? CONST_DISCUSS_MSG_TYPE.at : CONST_DISCUSS_MSG_TYPE.text;
            // console.error('=========', curIndex, sIndex, firstL, this.lunpanRoomSelectedUserData, this.lunpanRoomAllUserObject)
            var me = this;
            setTimeout(() => {
                me.clickFakeTextArea();
            }, 20);
        },
        // 替换发送消息里的'@昵称'为'@id'
        replaceAtContent(text) {
            _.forEach(this.lunpanRoomSelectedUserData, data=>{
                var nameText = '@'+data.nickname;
                if(text.indexOf(nameText) != -1) {
                    text = text.replace(nameText, '@'+data.uid);
                }
            });
            return text;
        },
        checkTextValue() {
            var me = this;
            _.forEach(this.lunpanRoomSelectedUserData, (data, index)=> {
                if(data) {
                    var atText = '@'+data.nickname;
                    if(me.textValue.indexOf(atText) == -1) {
                        me.$store.state.discuss.lunpanRoomSelectedUserData.splice(index, 1);
                        me.tempAtText.replace(atText, '');
                    }
                }
            });
            var len = this.lunpanRoomSelectedUserData.length;
            this.$store.state.discuss.curMsgType = len > 0 ? CONST_DISCUSS_MSG_TYPE.at : CONST_DISCUSS_MSG_TYPE.text;
            // console.error('checkTextValue------', this.lunpanRoomSelectedUserData, this.curMsgType);
        }
    }
}
</script>